module.exports = __webpack_public_path__ + "static/media/S14.5a8726da.png";